import { Button, Grid, Typography } from '@mui/material';
import { useCallback, useMemo } from 'react';

import { FddmServiceFactory } from '@/modules/canvas/services/Floorplan/FddmServiceFactory';
import { logger } from '@common/logging/logger';

import { DEBUG_ACTION_SIZE, DEBUG_DESCRIPTION_SIZE } from './DebugModal';

export const LogCurrentFddmButton = () => {
  const fddmSvc = useMemo(() => FddmServiceFactory.getInstance().createFddmService(), []);

  const handleClick = useCallback(() => {
    logger.info('[Debug] Current FDDM', fddmSvc.getModel());
  }, [fddmSvc]);

  return (
    <>
      <Grid item xs={DEBUG_DESCRIPTION_SIZE}>
        <Typography>Log current FDDM</Typography>
      </Grid>
      <Grid item xs={DEBUG_ACTION_SIZE}>
        <Button onClick={handleClick}>Click</Button>
      </Grid>
    </>
  );
};
